import cx from 'classnames';
import { Table, TableBody, TableRow, Text } from 'platform-components';
import { coursePropType } from 'platform-components/src/utils/data-prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import Head from './__head/lessons__head';
import { LessonsLikesPopup } from './__lesson-likes-popup/lessons__lesson-likes-popup';
import Lesson from './__lesson/lessons__lesson';

import './lessons.scss';

class Lessons extends React.Component {
    static propTypes = {
        checkShouldDisableLesson: PropTypes.func,
        compactView: PropTypes.bool,
        course: coursePropType,
        courseId: PropTypes.number.isRequired,
        customLessonNameColumnTitle: PropTypes.string,
        lessons: PropTypes.array.isRequired,
        mix: PropTypes.string,
        setLessonRef: PropTypes.func,
        shouldShowDuration: PropTypes.bool,
        shouldShowEvaluationDate: PropTypes.bool,
        shouldShowLikes: PropTypes.bool,
        shouldShowSettings: PropTypes.bool,
        shouldRenderEmptyMessage: PropTypes.bool,
        onLessonClick: PropTypes.func,
        onSettingsClick: PropTypes.func,
        onShowMore: PropTypes.func,
        subscriptions: PropTypes.object,
        clessonLikes: PropTypes.object,
    };

    static defaultProps = {
        shouldRenderEmptyMessage: true,
    };

    state = {
        likeHoverCLessonId: null,
        likeButtonRef: null,
        visiblePopup: false,
        likeClessonId: null,
    };

    renderLessons = () => {
        const {
            checkShouldDisableLesson,
            courseId,
            lessons,
            shouldShowDuration,
            shouldShowEvaluationDate,
            shouldShowLikes,
            shouldShowSettings,
            setLessonRef,
            onLessonClick,
            onSettingsClick,
            subscriptions,
            clessonLikes,
        } = this.props;

        return lessons.map((clesson, index) => {
            const subscriptionsList = subscriptions ? subscriptions[clesson.id] : [];
            const likesCount = clessonLikes?.[clesson.id] || 0;

            return (
                <Lesson
                    {...{ clesson, courseId, index }}
                    checkShouldDisableLesson={checkShouldDisableLesson}
                    course={this.props.course}
                    key={index}
                    likesCount={likesCount}
                    onHideLikesPopup={() => {
                        this.setState((prev) => ({
                            ...prev,
                            visiblePopup: false,
                        }));
                    }}
                    onLessonClick={onLessonClick}
                    onSetRef={(ref) => {
                        if (setLessonRef) {
                            setLessonRef(ref, index);
                        }
                    }}
                    onSettingsClick={onSettingsClick}
                    onShowLikesPopup={(clessonId, likeRef) => {
                        this.setState((prev) => ({
                            ...prev,
                            likeButtonRef: likeRef,
                            likeClessonId: clessonId,
                            visiblePopup: true,
                        }));
                    }}
                    shouldShowDuration={shouldShowDuration}
                    shouldShowEvaluationDate={shouldShowEvaluationDate}
                    shouldShowLikes={shouldShowLikes}
                    shouldShowSettings={shouldShowSettings}
                    subscriptions={subscriptionsList}
                />
            );
        });
    };

    renderMoreLessonPanel = () => {
        const { onShowMore } = this.props;

        return (
            <TableRow mix="lessons__more-lessons-panel" onClick={onShowMore}>
                <Text id="lessons.showMore" weight={Text.WEIGHT.M} />
            </TableRow>
        );
    };

    render() {
        const { compactView, mix, shouldShowLikes } = this.props;

        return (
            <>
                <Table mix={cx('lessons', mix)}>
                    <Head shouldShowLikes={shouldShowLikes} />
                    <TableBody mix="lessons__table-body">
                        {this.renderLessons()}
                        {compactView && this.renderMoreLessonPanel()}
                    </TableBody>
                </Table>
                {shouldShowLikes && (
                    <LessonsLikesPopup
                        anchorRef={this.state.likeButtonRef}
                        clessonId={this.state.likeClessonId}
                        onClose={() => {
                            this.setState((prev) => ({ ...prev, visiblePopup: false }));
                        }}
                        visible={this.state.visiblePopup}
                    />
                )}
            </>
        );
    }
}

export default Lessons;
